export default (api) => ({
  fetchVersions: (instanceId, params) => api.$get(`/instances/${instanceId}/versions`, { params }),

  fetchAgenciesByVersion: (instanceId, version, params) =>
    api.$get(`/instances/${instanceId}/versions/${version}/agencies`, { params }),

  fetchEvolutionStats: (range, agencyId) =>
    api.$get(`${agencyId ? `agencies/${agencyId}/` : ""}stats/evolution/${range}`),

  preparecsv: (instanceId, version, params) =>
    api.$get(`/instances/${instanceId}/versions/${version}/preparecsv`, { params }),
});
